module.exports = __webpack_public_path__ + "img/profile-bg.650dbf84.jpg";